import React from "react";
import { withRouter } from 'react-router-dom'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Tooltip from "@material-ui/core/Tooltip";
// import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";


function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class WorkSection extends React.Component {
  state = {
    mailError: false,
    nameError: false,
    messageError: false,
    open: false
  }

  handleClose = () => {
    this.setState({ open: false });
    this.props.history.push("/")
  };

  handleChange = value => {
    this.setState({
      ...this.state,
      ...value,
      subject: "Email from Contact Us Sandton Website.",
      mailError: false
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    let emailContent = this.state

    let validate = () => {
      if (
        emailContent.name === undefined || emailContent.email === undefined || emailContent.message === undefined
        || emailContent.name === "" || emailContent.email === "" || emailContent.message === ""
      ) {
        this.setState({
          ...this.state,
          error: true
        })
        return true
      }
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailContent.email)) {
        this.setState({
          ...this.state,
          mailError: true
        })
        return true
      } else {
        return false
      }
    }

    let isError = validate()

    if (!isError) {
      let email = JSON.stringify(emailContent)
      let oReq = new XMLHttpRequest();
      oReq.open("POST", "http://kapbr.com/", true);
      oReq.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      oReq.addEventListener("load", () => {
        console.log(oReq.status)
        if (oReq.readyState === 4 && oReq.status === 200) {
          this.setState({
            ...this.state,
            open: true
          })
        } else { console.log("NOT SENT") }
      })
      oReq.send("requeststring=" + email);
    }
  }

  render() {
    const { classes } = this.props;
    const { name, email, message } = this.state
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem cs={12} sm={12} md={8}>
            {/* <h2 className={classes.title}>Work with us</h2> */}
            <h3 className={classes.title} style={{ color: "#4BB64B" }}>PT SANDTON SUKSES BERSAMA</h3>
            <h4 className={classes.description}>

              Jl. Utan Panjang III no 19-20 Kemayoran, Jakarta, Indonesia
              <br />
              Phone +62 21 4212085
              <br />
              Whatsapp  +62 811 3477 743
            <div>
                <Tooltip
                  id="instagram-tooltip"
                  title="Follow us on Linked in"
                  placement={window.innerWidth > 959 ? "bottom" : "left"}
                // classes={{ tooltip: classes.tooltip }}
                >
                  <Button href="https://www.linkedin.com/in/sandtonglobal/" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
                    <i className={"fab fa-linkedin"} />
                  </Button>
                </Tooltip>
                <Tooltip
                  id="instagram-tooltip"
                  title="Follow us on Twitter"
                  placement={window.innerWidth > 959 ? "bottom" : "left"}
                // classes={{ tooltip: classes.tooltip }}
                >
                  <Button href="https://twitter.com/Sandton_Global" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
                    <i className={"fab fa-twitter"} />
                  </Button>
                </Tooltip>
                <Tooltip
                  id="instagram-tooltip"
                  title="Follow us on Instagram"
                  placement={window.innerWidth > 959 ? "bottom" : "left"}
                // classes={{ tooltip: classes.tooltip }}
                >
                  <Button href="https://www.instagram.com/sandtonglobal/" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
                    <i className={"fab fa-instagram"} />
                  </Button>
                </Tooltip>
                {/* <Tooltip
                  id="instagram-tooltip"
                  title="Follow us on Medium"
                  placement={window.innerWidth > 959 ? "bottom" : "left"}
                // classes={{ tooltip: classes.tooltip }}
                >
                  <Button href="https://medium.com/@sandtonglobal" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
                    <i className={"fab fa-medium"} />
                  </Button>
                </Tooltip> */}
                <Tooltip
                  id="instagram-tooltip"
                  title="Follow us on Facebook"
                  placement={window.innerWidth > 959 ? "bottom" : "left"}
                // classes={{ tooltip: classes.tooltip }}
                >
                  <Button href="https://www.facebook.com/sandtonglobal/" target="_blank" rel="noopener noreferrer" justIcon link className={classes.margin5}>
                    <i className={"fab fa-facebook"} />
                  </Button>
                </Tooltip>
              </div>
            </h4>
            <h3 className={classes.title} style={{ color: "#4BB64B" }}>Branch Office</h3>
            <h4 className={classes.description}>
              Ruko Bukit Cimannggu Villa C No 12 Bogor - Indonesia
            </h4>
            <h3 className={classes.title} style={{ color: "#4BB64B" }}>Email to :</h3>
            <h4 className={classes.description}>
              sales@sandtonglobal.com
            </h4>
            <form onSubmit={this.handleSubmit} >
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    onInputChange={this.handleChange}
                    labelText="Your Name"
                    id="name"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    error={this.state.mailError}
                    onInputChange={this.handleChange}
                    labelText={this.state.mailError ? "Enter the correct email format" : "Your Email"}
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                  />
                </GridItem>
                <CustomInput
                  labelText="Your Message"
                  id="message"
                  onInputChange={this.handleChange}
                  formControlProps={{
                    fullWidth: true,
                    className: classes.textArea
                  }}
                  inputProps={{
                    multiline: true,
                    rows: 5
                  }}
                />
                <GridContainer justify="center">
                  <GridItem
                    xs={12}
                    sm={12}
                    md={4}
                    className={classes.textCenter}
                  >
                    <Button
                      type='submit'
                      color="primary"
                      disabled={
                        message === undefined || name === undefined || email === undefined
                          || message === "" || name === "" || email === ""
                          ? true
                          : false
                      }
                    >
                      Send Message
                    </Button>
                  </GridItem>
                </GridContainer>
              </GridContainer>
            </form>
          </GridItem>


          <Dialog
            open={this.state.open}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            {/* <DialogTitle id="alert-dialog-slide-title">
              {"Sending Email"}
            </DialogTitle> */}
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Your message has been sent.
              </DialogContentText>
            </DialogContent>
            <DialogActions style={{ alignItems: 'center' }} >
              <Button onClick={this.handleClose} color="primary">
                Close
            </Button>
            </DialogActions>
          </Dialog>

        </GridContainer>
      </div >
    );
  }
}

export default withRouter(withStyles(workStyle)(WorkSection));



// WEBPACK FOOTER //
// ./src/views/ContactPage/Sections/WorkSection.jsx